<style lang="less">
.refund-handle {
  text-align: left;
  .el-button {
    padding: 0 5px;
  }
  .el-button+.el-button {
    margin: 0;
  }
}
</style>
<template>
    <el-card>
      <div slot="header">
        <h1 style="display: inline-block">退款单管理</h1>
        <el-button style="float: right" @click="addRefundOrder" type="primary">添加退款单</el-button>
      </div>
      <el-form inline :model="query" class="filter-form" ref="filterForm" >
        <el-form-item style="margin-top: 15px;">
          <el-input placeholder="请输入内容" v-model.trim="searchValue" class="input-with-select">
            <el-select v-model="searchName" slot="prepend" placeholder="请选择" style="width:100px">
              <el-option label="订单号" value="order_sn"></el-option>
              <el-option label="账号" value="account"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <!-- <el-form-item label="商品名称/编码">
          <SpecPicker
            v-model="orderProductQuery.sku"
            action="product-specs"
            labelField=""
            valueField=""
            keywordField="name"
            _placeholder="商品名或sku"
          >
          </SpecPicker>
        </el-form-item> -->

        <el-form-item label="申请状态">
          <el-select
            v-model="query.status"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in $enums.refundStatus.getList()"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
         <!-- <el-form-item label="退款类型">
          <el-select v-model="query.type" clearable placeholder="请选择">
            <el-option  v-for="item in $enums.refundTypes.getList()" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item label="申请时间">
          <el-date-picker
            v-model="query.createdAt"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>

        <!-- <el-form-item label="内购活动">
          <el-select
            v-model="query.activityId"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in activities"
              :key="item.id"
              :label="item.activityName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-button
            type="primary"
            @click="queryCollection"
          >查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click.native="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table
        class="table block"
        v-loading="loading"
        :data="collection"
      >
        <el-table-column label="订单号" 
          min-width="160">
          <template slot-scope="scope">
            <p>
              <a class="text-blue">{{scope.row.order.orderSn}}</a>
              <i class="el-icon-document-copy" style="color:#1890ff;margin-left:10px" @click="copy(scope.row.order.orderSn)"></i>
            </p>
            <p>{{scope.row.createdAt}}</p>
          </template>
        </el-table-column>
        <el-table-column label="下单人">
          <template slot-scope="scope">
            <p>{{scope.row.member.account}}</p>
          </template>
        </el-table-column>
        <!-- <el-table-column label="收件人">
          <template slot-scope="scope">
            <p>{{scope.row.order.consignee}}</p>
            <p>{{scope.row.order.region}} {{scope.row.order.address}}</p>
            <p>{{scope.row.order.mobile}}</p>
          </template>
        </el-table-column> -->
        <el-table-column
          label="订单商品"
          min-width="100"
        >
          <template slot-scope="scope">
            <p
              v-for="(orderProduct, index) in scope.row.order.orderProducts"
              :key="index"
            >
              {{orderProduct.productName}}
              <divider v-if="scope.row.order.orderProducts.length > 1 && index != scope.row.order.orderProducts.length - 1" />
            </p>
          </template>
        </el-table-column>

        <el-table-column label="退款原因">
          <div slot-scope="scope">
            {{ scope.row.reason }}
          </div>
        </el-table-column>
        <el-table-column
          prop="orderAmount"
          label="退款金额"
        >
          <div slot-scope="scope">
            {{ scope.row.order.orderAmount }}
          </div>
        </el-table-column>
        <el-table-column label="申请状态">
          <div slot-scope="scope">
            {{ $enums.refundStatus.label(scope.row.status) }}
          </div>
        </el-table-column>
        <!-- <el-table-column label="退款类型">
          <div slot-scope="scope">
            {{ $enums.refundTypes.label(scope.row.type) }}
          </div>
        </el-table-column> -->
        <el-table-column
          align="center"
          label="操作"
          width= '220'
        >
          <template slot-scope="scope">
            <div class="refund-handle">
              <el-button v-if="scope" type="text" @click="look(scope.row)" >查看日志</el-button>
                <el-button v-if="scope.row.status == $enums.refundStatus.RO_SHIPPED" type="text" @click="infoShow(scope.row)">寄回信息</el-button>
                <el-button v-if="scope.row.status == $enums.refundStatus.RO_SHIPPED" type="text"  @click="agree(scope.row)">同意退款</el-button>
                <el-button v-if="scope.row.status == $enums.refundStatus.RO_SHIPPED" type="text" style="color:red;" @click="refuse(scope.row)">拒绝退货</el-button>

                  <el-button v-if="scope.row.status == $enums.refundStatus.RO_UNSETTLED&&scope.row.type == $enums.refundTypes.REFUND" type="text"  @click="agree(scope.row)" >同意退款</el-button>
                  <el-button v-if="scope.row.status == $enums.refundStatus.RO_UNSETTLED&&scope.row.type == $enums.refundTypes.REFUND" type="text"  style="color:red;" @click="refuse(scope.row)">拒绝退款</el-button>

                  <el-button v-if="scope.row.status == $enums.refundStatus.RO_UNSETTLED&&scope.row.type == $enums.refundTypes.RETURN" type="text"  @click="agreeReturn(scope.row)">同意退货</el-button>
                  <el-button v-if="scope.row.status == $enums.refundStatus.RO_UNSETTLED&&scope.row.type == $enums.refundTypes.RETURN" type="text"  style="color:red;" @click="refuse(scope.row)">拒绝退货</el-button>
            </div>

          </template>
        </el-table-column>

      </el-table>
      <pagination
        :total="total"
        :pagination="pagination"
        :changed="queryCollection"
      />
    <el-drawer
      :visible.sync="drawerVisible"
      :before-close="drawerClose"
      :show-close="false"
      size="40%"
    >
      <div class="flex flex-row flex-sb flex-center"  style="padding: 0 20px;">
        <span>订单号: {{ lookOrder && lookOrder.order.orderSn}}</span>
        <el-button type="primary" @click="drawerClose">关闭</el-button>
      </div>
      <el-table class="table block" :data="recordCollection">
        <el-table-column label="操作人员">
          <div slot-scope="scope">
            {{ scope.row.admin ? scope.row.admin.name : '前端用户'}}
          </div>
        </el-table-column>
        <el-table-column
          label="操作"
          prop="refundDesc"
        ></el-table-column>
        <el-table-column
          label="操作时间"
          prop="createdAt"
        ></el-table-column>
        <el-table-column
          label="操作结果"
          prop="result"
        ></el-table-column>
      </el-table>
      <pagination
        :total="recordTotal"
        :pagination="recordPagination"
        :changed="queryCollectionRecord"
      />
    </el-drawer>
    <el-drawer :visible="detailShow" :before-close="infoClose" :show-close="false" size="40%">
      <div class="flex flex-row flex-sb flex-center"  style="padding: 0 20px;">
        <span>订单号: {{ detail.order && detail.order.orderSn}}</span>
        <el-button type="primary" @click="infoClose">关闭</el-button>
      </div>
      <!-- <div style="padding: 0 20px;">
        <p style="padding:10px 0px">快递公司：<span>{{ detail.expressName}}</span></p>
        <p>快递单号：<span>{{ detail.expressNumber}}</span><i class="el-icon-document-copy" style="color:#1890ff;margin-left:10px" @click="copy(detail.expressNumber)"></i></p>
      </div> -->
      <el-table style="padding: 0 20px;" class="table block" :data="[{expressName: detail.expressName, expressNumber: detail.expressNumber}]">
        <el-table-column
          label="寄回快递公司"
          prop="expressName"
        ></el-table-column>
        <el-table-column
          label="寄回单号"
        >
          <template slot-scope="scope">
            <p>
              <a>{{scope.row.expressNumber}}</a>
              <i class="el-icon-document-copy" style="color:#1890ff;margin-left:10px" @click="copy(scope.row.expressNumber)"></i>
            </p>
          </template>
        </el-table-column>
      </el-table>
    </el-drawer>
    <input
      type="text"
      ref="copySn"
      id="copySn"
      style="display: block;position: absolute;z-index: -10;"
      v-bind:value="copySn"
    >

    <el-dialog title="添加退款单" :visible.sync="dialogFormVisible" width="400px">
      <el-form :model="refundOrderForm" ref="refundOrderForm" :rules="rules">
        <el-form-item label="" label-width="auto" prop='orderSn'>
          <el-input placeholder="请输入需要退款的订单号" v-model="refundOrderForm.orderSn" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="" label-width="auto" prop="reason">
          <el-select placeholder="请选择退款原因" v-model="refundOrderForm.reason" style="width: 100%">
            <el-option
              v-for="item in refundReason"
              :key="item.value"
              :label="item.label"
              :value="item.label">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="createOrderRefund">确 定</el-button>
      </div>
    </el-dialog>
    </el-card>


</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import moment from 'moment'
import SpecPicker from "@/components/SpecPicker";
import Divider from '../../components/Divider/index'

const { mapGetters } = createNamespacedHelpers('refundOrders')
const operationRecordHelpers = createNamespacedHelpers('operationRecord')
// const { mapGetters: mapActivitiesGetters } = createNamespacedHelpers('activities')

export default {
  data() {
    return {
      lookOrder: null,
      detail: {expressName:"",expressNumber:""},
      detailShow: false,
      copySn: '',
      drawerVisible: false,
      infoVisible: false,
      loading: false,
      searchValue: '',
      searchName: '',
      query: {
        order_sn: '',
        account: '',
        status: '',
        createdAt: [],
      },
      refundOrderForm: {
        orderSn: '',
        reason: ''
      },
      dialogFormVisible: false,
      refundReason: [{value: '1', label: '不想要了'},{value: '2', label: '订单商品与实物不符'},{value: '3', label: '商品有瑕疵'}],
      statusFields: [
        {
          label: '申请状态',
          field: 'refundStatus'
        }
      ],
      rules: {
        orderSn: [{ required: true, message: '请输入需要退款的订单号', trigger: 'blur' },],
        reason: [{ required: true, message: '请选择退款原因', trigger: 'blur' },]
      }
    }
  },
  components: {
    SpecPicker,
    Divider
  },
  computed: {
    ...mapGetters(['collection', 'total', 'pagination']), // 映射必要数据
    ...operationRecordHelpers.mapGetters({
      recordCollection: 'collection',
      recordTotal: 'total',
      recordPagination: 'pagination',
    })
    // ...mapActivitiesGetters({ activities: 'collection' })
  },
  methods: {
    addRefundOrder() {
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['refundOrderForm'].resetFields()
      })
    },
    async createOrderRefund() {
      try {
        const data = await this.$store.dispatch('refundOrders/addRefundOrder', this.refundOrderForm)
        this.dialogFormVisible = false
        if (data) {
            if (data.type == 'refund') {
                this.$message.success('添加退款单成功')
            } else {
                this.$message.warning('当前订单已发货，以为您移动到退货单列表')
            }
        }
      } finally {
        await this.queryCollection({ pagination: this.pagination })
      }
    },
    async agree(order) {
      try {
        await this.$confirm('同意退款后订单款项将原路返回至用户支付账户，无法取消请谨慎操作!', '提示', {
          confirmButtonText: '确定退款',
          cancelButtonText: '取消',
        })
        await this.$store.dispatch('refundOrders/changeRefundOrderStatus', {
          id: order.id,
          status: this.$enums.refundStatus.RO_REFUND
        })
      } finally {
        await this.queryCollection({ pagination: this.pagination })
      }
    },
    async agreeReturn(order) {
      try {
        await this.$confirm('管理员确认后同意退货成功，退款单状态更新为“待买家寄回”!', '提示', {
          confirmButtonText: '确定同意',
          cancelButtonText: '取消',
        })
        await this.$store.dispatch('refundOrders/changeRefundOrderStatus', {
          id: order.id,
          status: this.$enums.refundStatus.RO_AGREE_RETURN, 
        })
      } finally {
        await this.queryCollection({ pagination: this.pagination })
      }
    },
    async refuse(order) {
      try {
        await this.$confirm('拒绝退款后，售中退款单将关闭，如需退款需用户重新发起申请!', '提示', {
          confirmButtonText: '确定拒绝',
          cancelButtonText: '取消',
        })

        await this.$store.dispatch('refundOrders/changeRefundOrderStatus', {
          id: order.id,
          status: this.$enums.refundStatus.RO_REFUSE
        })
      } finally {
        await this.queryCollection({ pagination: this.pagination })
      }
    },
    async resetQuery() {
      this.query = {
        order_sn: '',
        account: '',
        status: '',
        createdAt: '',
      }
      this.queryCollection()
    },
    async queryCollection({ pagination = {} } = {}) {
      const query = {
        type:'refund',
        order_sn: this.searchName==='order_sn'?this.searchValue:'',
        account: this.searchName==='account'?this.searchValue:'',
        status: this.query.status === '' ? -1 : this.query.status,
        start_time: this.query.createdAt && this.query.createdAt[0] ? moment(this.query.createdAt[0]).format('YYYY-MM-DD') + ' 00:00:00' : '',
        end_time: this.query.createdAt && this.query.createdAt[1] ? moment(this.query.createdAt[1]).format('YYYY-MM-DD') + ' 23:59:59' : ''
      }
      try {
        this.loading = true
        await this.$store.dispatch('refundOrders/collection', { ...query, ...pagination })
      } finally {
        this.loading = false
      }
    },
    async queryCollectionRecord({ pagination = {} } = {}) {
      pagination.limit = 10
      await this.$store.dispatch('operationRecord/collection', {
        pagination,
        query: {
          refundAppliesId: this.lookOrder.id,
        },
        withRels: ['admin']
      })
    },
    // 查看日志
    async look(order) {
      this.lookOrder = order
      await this.queryCollectionRecord()
      this.drawerVisible = true
    },
    drawerClose() {
      this.drawerVisible = false
    },
    infoClose() {
        this.detailShow = false
    },

    infoShow(order) {
      console.log('212',order);
      this.detail = order
      this.detailShow = true
    },

    // 复制
    copy(sn) {
      this.copySn = sn;
      this.$nextTick(() => {
        var copySn = this.$refs.copySn;
        copySn.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message.success('复制成功')
      })
    },
  },
  mounted() {
    // this.$store.dispatch('activities/collection', { pagination: { limit: 100 } })
    this.queryCollection()
  },
  activated() {
    this.queryCollection()
  }
}
</script>
